import React from 'react';
import './SpinnerLoader.css'
const SpinnerLoader = () => {
  return (
    <div className="custom-loader-spinner"></div>
  );
};

export default SpinnerLoader;